import Swiper from 'swiper';
import {Autoplay, Pagination} from 'swiper/modules';

// import 'swiper/css';
// import 'swiper/css/pagination';

export default class BrandsSlider {
    constructor() {
        const $sections = document.querySelectorAll('section.brands-slider');

        $sections.forEach($section => {
            const swiper = new Swiper($section.querySelector('.swiper'), {
                // configure Swiper to use modules
                modules: [Pagination, Autoplay],
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    bulletElement: 'button',
                    bulletActiveClass: 'active !opacity-100',
                    bulletClass: 'transition-opacity cursor-pointer opacity-60 bg-secondary w-4 h-4 inline-block rounded-full',
                    // dynamicBullets: true
                },
                speed: 750,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
                // loop: true,
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 10,
                centerInsufficientSlides: true,
                breakpoints: {
                    640: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    },
                    1024: {
                        slidesPerView: 5,
                        slidesPerGroup: 1,
                    }
                }
            });
        });
    }


}
new BrandsSlider();

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".brands-slider .swiper-pagination button").forEach((element) => {
        element.setAttribute('aria-label', 'slider-dot');
    })
})